module.exports = __webpack_public_path__ + "static/media/verified.b2bbe6d0.svg";